import { Link } from "react-router-dom";
import { Linkedin } from "lucide-react";
import { Logo } from "@/components/Logo";
import { SERVICES } from "@/data/services";
import { SECTORS } from "@/data/sectors";

const productLinks = [
  { to: "/diensten", label: "Diensten" },
  { to: "/methode", label: "Methode" },
  { to: "/digitale-regie", label: "Digitale regie" },
  { to: "/voor-wie", label: "Voor wie" },
  { to: "/over-soveu", label: "Over SovEU" },
  { to: "/inzichten", label: "Inzichten" },
  { to: "/contact", label: "Contact" },
];

const legalLinks = [
  { to: "/privacybeleid", label: "Privacybeleid" },
  { to: "/algemene-voorwaarden", label: "Algemene voorwaarden" },
];

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-[#E5E9EF] bg-white"
    >
      <div className="container-soveu pt-16 pb-10">
        <div className="grid lg:grid-cols-12 gap-10">
          {/* Brand block */}
          <div className="lg:col-span-4">
            <div className="mb-5 inline-block" style={{ color: "#1E3A5F" }}>
              <Logo size={84} wordmarkSize="text-[30px]" />
            </div>
            <p className="text-[15px] text-[#334155] leading-relaxed mt-2 mb-5 max-w-md">
              AI governance, datagovernance en digitale regie voor publieke en semipublieke organisaties.
            </p>
            <address className="not-italic text-[15px] text-[#334155] leading-relaxed">
              Utrecht, Nederland
              <br />
              <a
                href="mailto:info@soveu.nl"
                className="hover:text-[#1E3A5F] transition-colors"
                data-testid="footer-email"
              >
                info@soveu.nl
              </a>
              <br />
              <span className="text-[#6B7280]">KVK 42033105</span>
            </address>
          </div>

          {/* Site links */}
          <div className="lg:col-span-2">
            <div className="text-[13px] font-semibold tracking-[0.14em] uppercase mb-5" style={{ color: "#1E3A5F" }}>
              Praktijk
            </div>
            <ul className="space-y-3 text-[15px]">
              {productLinks.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    className="text-[#1A1A1A] hover:text-[#1E3A5F] transition-colors"
                    data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Dienstpagina's */}
          <div className="lg:col-span-3">
            <div className="text-[13px] font-semibold tracking-[0.14em] uppercase mb-5" style={{ color: "#1E3A5F" }}>
              Diensten
            </div>
            <ul className="space-y-3 text-[15px]">
              {SERVICES.map((s) => (
                <li key={s.to}>
                  <Link
                    to={s.to}
                    className="text-[#1A1A1A] hover:text-[#1E3A5F] transition-colors"
                    data-testid={`footer-dienst-${s.slug}`}
                  >
                    {s.navLabel}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Sectoren + Juridisch */}
          <div className="lg:col-span-3">
            <div className="text-[13px] font-semibold tracking-[0.14em] uppercase mb-5" style={{ color: "#1E3A5F" }}>
              Sectoren
            </div>
            <ul className="space-y-3 text-[15px] mb-8">
              {SECTORS.map((s) => (
                <li key={s.to}>
                  <Link
                    to={s.to}
                    className="text-[#1A1A1A] hover:text-[#1E3A5F] transition-colors"
                    data-testid={`footer-sector-${s.slug}`}
                  >
                    {s.navLabel}
                  </Link>
                </li>
              ))}
            </ul>

            <div className="text-[13px] font-semibold tracking-[0.14em] uppercase mb-5" style={{ color: "#1E3A5F" }}>
              Juridisch
            </div>
            <ul className="space-y-3 text-[15px] mb-8">
              {legalLinks.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    className="text-[#1A1A1A] hover:text-[#1E3A5F] transition-colors"
                    data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
            <a
              href="https://www.linkedin.com/company/soveu/"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 text-[#1A1A1A] hover:text-[#1E3A5F] transition-colors text-[14px]"
              data-testid="footer-linkedin"
            >
              <Linkedin size={16} /> LinkedIn
            </a>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-[#E5E9EF] flex flex-col md:flex-row md:items-center md:justify-between gap-3 text-[13px] text-[#6B7280]">
          <span>© 2026 SovEU</span>
          <span className="italic" data-testid="footer-tagline">
            Van compliance naar controle. Van afhankelijkheid naar regie.
          </span>
        </div>
      </div>
    </footer>
  );
}
